import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/tracing";
import * as process from "process";
import {BrowserOptions} from "@sentry/browser";
import {TeamType} from "data/enums";
import argosLogo from "assets/theme/ARGOS/argos_logo.svg";
import argosBg from "assets/theme/ARGOS/argos_bg_UNCOMPRESSED.jpg";
import elksLogo from "assets/theme/ELKS/elks_logo.svg";
import elksBg from "assets/theme/ELKS/elks_bg_UNCOMPRESSED.jpg";
import elksBgMWeb from "assets/theme/ELKS/elks_bg_mweb_UNCOMPRESSED.jpg";
import elksAltBg from "assets/theme/ELKS/elks_alt_bg.jpg";
import elksSponsorLogo from "assets/theme/ELKS/elks_sponsor_logo.png";
import elksSponsorLogoBlack from "assets/theme/ELKS/elks_sponsor_logo_color.png";
import elksMainBanner from "assets/theme/ELKS/elks_main_banner.png";
import elksSecondBanner from "assets/theme/ELKS/elks_second_banner.jpg";
import lionsBg from "assets/theme/LIONS/lions_bg.jpg";
import lionsLogo from "assets/theme/LIONS/lions_logo.svg";
import lionsChipsLogo from "assets/theme/LIONS/bc_lions_chips_logo.png";
import lionsSponsorLogo from "assets/theme/LIONS/lion_sponsor_logo.png";
import lionsMainBanner from "assets/theme/LIONS/bcMainBanner.gif";
import lionsMainBanner970 from "assets/theme/LIONS/bc_970x90.gif";
import lionsMainBanner728 from "assets/theme/LIONS/bc_728.gif";
import lionsSponsorLogoBlack from "assets/theme/LIONS/lion_sponsor_logo_color.png";
import redblacksBg from "assets/theme/REDBLACKS/redblacks_bg.jpg";
import redblacksLogo from "assets/theme/REDBLACKS/redblacks_logo.svg";
import alsBg from "assets/theme/ALS/als_bg.jpg";
import alsLogo from "assets/theme/ALS/als_logo.svg";
import alsSponsorLogo from "assets/theme/ALS/als_sponsor_logo.png";
import alsSponsorLogoAlt from "assets/theme/ALS/als_sponsor_logo_header_red.png";
import alsMainBanner from "assets/theme/ALS/als_main_banner.jpg";
import alsMainBannerMobileFr from "assets/theme/ALS/als_728x90_fr.jpg";
import alsMainBannerMobile from "assets/theme/ALS/als_728x90_en.jpg";
import alsMainBannerFr from "assets/theme/ALS/als_main_banner_fr.jpg";
import ticatsBg from "assets/theme/TICATS/tigers_bg.jpg";
import ticatsLogo from "assets/theme/TICATS/tigers_logo.svg";
import bombersBg from "assets/theme/BOMBERS/bombers_bg.jpg";
import bombersLogo from "assets/theme/BOMBERS/bombers_logo.svg";
import bombersAltLogo from "assets/theme/BOMBERS/bombers_alt_logo.svg";
import sponsorBannerSideBarBombers from "assets/theme/BOMBERS/sponsorBannerSidebar.jpg";
import sponsorBannerMobileBombers from "assets/theme/BOMBERS/sponsorBanner.jpg";

import stampsBg from "assets/theme/STAMPS/stamps_bg.jpg";
import stampsLogo from "assets/theme/STAMPS/stamps_logo.svg";
import stampsMainBanner from "assets/theme/STAMPS/stamps_main_banner.jpg";
import stampsMainBannerMobile from "assets/theme/STAMPS/stamps_main_mobile.jpg";
import stampsSecondBanner from "assets/theme/STAMPS/stamps_second_banner.jpg";
import ridersBg from "assets/theme/RIDERS/riders_bg.jpg";
import ridersLogo from "assets/theme/RIDERS/riders_logo.svg";
import ticatsSponsorLogoHeader from "assets/theme/TICATS/ticats_sponsor_logo_header.svg";
import ticatsSponsorLogo from "assets/theme/TICATS/ticats_sponsor_logo.svg";

export * from "./AwsAmplifyError";

export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const CONTENT_JSON_URL = process.env.REACT_APP_CONTENT_JSON_URL || "";
export const GAME_ZONE_JSON_URL = process.env.REACT_APP_GAME_ZONE_JSON_URL || "";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const MAIN_URL = process.env.REACT_APP_MAIN_URL || "";
export const LOCO_JSON_URL = process.env.REACT_APP_LOCO_JSON_URL || "";
export const STATIC_CONTENT_JSON_URL = process.env.REACT_APP_STATIC_CONTENT_JSON_URL || "";
export const IS_LOCAL_BUILD = process.env.NODE_ENV === "development";
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "uat";
export const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV || "development";
export const SITE_URL = window.location.origin || "";
export const PUBLIC_URL = process.env.REACT_APP_SITE_URL || "";
export const GAME_ZONE_IMAGES_URL = process.env.REACT_APP_GAME_ZONE_IMAGES_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";
export const TRIALFIRE_TEAM = process.env.REACT_APP_GA_TRIALFIRE_TEAM || "";
export const TEAM_PREFIX = (process.env.REACT_APP_TEAM_PREFIX || TeamType.ALS) as TeamType;
export const FACEBOOK_ID = process.env.REACT_APP_FACEBOOK_APP_ID || false;

export const OVERRIDE_LANG = process.env.REACT_APP_LANG;

export const SHARE_PATH = process.env.REACT_APP_SHARE_PATH || "";

export const SKIP_TRANSLATIONS =
	new URLSearchParams(window.location.search).get("skipTranslation") === "true";

export const GAME_ID = Number(process.env.REACT_APP_GAME_ID || "");

export const CONTEST_ROUTES = [{path: "/contest/:id"}, {path: "/contest/:id/result"}];

export const FORM_VALIDATION_ELEMENT_CLASSNAME = "form-field-validate" as const;

export const GAMEZONE_LINKS_MAPPER = {
	"en-US": "https://gamezone.cfl.ca",
	"fr-CA": "https://zonejeux.lcf.ca",
	en: "https://gamezone.cfl.ca",
	fr: "https://zonejeux.lcf.ca",
} as const;

export const SENTRY_CONFIG: BrowserOptions = {
	dsn: "https://1a7200792cd14b558c39a0eb241f5f93@o151969.ingest.sentry.io/6439047",
	release: "2.0.0",
	integrations: [
		new BrowserTracing(),
		new Sentry.Integrations.Breadcrumbs({
			console: false,
		}),
	],
	environment: SENTRY_ENV,
	allowUrls: ["blitzpicks.cfl.ca", "gamezone.cfl.ca", "zonejeux.lcf.ca", "geniussports.com"],
	denyUrls: [
		"quantcast",
		"xsca",
		// browser's extensions
		/extensions\//i,
		/^chrome:\/\//i,
		/^moz-extension:\/\//i,
	],
	sampleRate: 0.1,
};

export const IS_SECRET_ENABLED = Boolean(
	JSON.parse(process.env.REACT_APP_IS_SECRET_ENABLED || "false")
);

export const OTHER_LANG_URL = process.env.REACT_APP_OTHER_LANG_URL || "";

export const DATE_FORMAT_BY_LOCALE = {
	en: "MMM-dd h:mma ZZZZ",
	fr: "dd MMM à HH:mm ZZZZ",
};

const ALLOWED_LANGUAGES_STRING = "en,fr";
export const ALLOWED_LANGUAGES = ALLOWED_LANGUAGES_STRING.split(",").map((lang) => lang.trim());

interface ISponsorData {
	sponsorLogo?: string;
	sponsorLogoHeader?: string;
	sponsorLogoAlt?: string;
	chipsLogo?: string;
	sponsorLogoAltRegistrationEnabled?: boolean;
	sponsorLink?: string;
	mainBanner?: string;
	mainBannerLink?: string;
	secondBanner?: string;
	secondBannerLink?: string;
	mobileBanner?: {appearance?: {minWidth: string; maxWidth: string}; image: string}[];
	mobileBannerLink?: string;
}

interface ITeamData {
	logo: string;
	altLogo?: string;
	background: string;
	altBackground?: string;
	mobileBackground?: string;
	name: string;
	sponsorData?: ISponsorData;
	hideGetChips?: boolean;
	registrationFields: {
		terms: boolean;
		marketing: boolean;
		sponsor: boolean;
	};
	hidePrizePage: boolean;
}

interface ILangProjectData {
	link: string;
	adBanner: string;
	adMobileBanner: string;
}

/* eslint-disable sonarjs/no-duplicate-string */
export const TEAM_DATA: ITeamData = {
	get [TeamType.ALS]() {
		const data: Record<string, ILangProjectData> = {
			fr: {
				link: "https://miseojeuplus.espacejeux.com/sports/fr/sports/competition/593/football/canada/cfl/matches",
				adBanner: alsMainBannerFr,
				adMobileBanner: alsMainBannerMobileFr,
			},
			en: {
				link: "https://miseojeuplus.espacejeux.com/sports/en/sports/competition/593/football/canada/cfl/matches",
				adBanner: alsMainBanner,
				adMobileBanner: alsMainBannerMobile,
			},
		};

		const langData = data[OVERRIDE_LANG || "en"] || data["en"];

		return {
			logo: alsLogo,
			background: alsBg,
			name: "header.team.als_name",
			registrationFields: {
				terms: true,
				marketing: true,
				sponsor: false,
			},
			sponsorData: {
				sponsorLogo: alsSponsorLogoAlt,
				sponsorLogoHeader: alsSponsorLogo,
				sponsorLogoAlt: alsSponsorLogoAlt,
				sponsorLink: langData.link,
				mainBannerLink: langData.link,
				secondBannerLink: langData.link,
				mainBanner: langData.adBanner,
				secondBanner: langData.adBanner,
				mobileBanner: [
					{
						image: langData.adMobileBanner,
					},
				],
				mobileBannerLink: langData.link,
			},
			hidePrizePage: false,
		};
	},
	[TeamType.ARGOS]: {
		logo: argosLogo,
		background: argosBg,
		registrationFields: {
			terms: false,
			marketing: true,
			sponsor: false,
		},
		name: "header.team.argos_name",
		hideGetChips: true,
		hidePrizePage: true,
	},
	[TeamType.BOMBERS]: {
		logo: bombersLogo,
		altLogo: bombersAltLogo,
		background: bombersBg,
		name: "header.team.bombers_name",
		registrationFields: {
			terms: true,
			marketing: true,
			sponsor: false,
		},
		sponsorData: {
			sponsorLink: "https://www.playnow.com/mb/sports/promotions/bombers-free-20/",
			mainBanner: sponsorBannerSideBarBombers,
			mainBannerLink: "https://www.playnow.com/mb/sports/promotions/bombers-free-20/",
			secondBanner: sponsorBannerSideBarBombers,
			secondBannerLink: "https://www.playnow.com/mb/sports/promotions/bombers-free-20/",
			mobileBanner: [
				{
					image: sponsorBannerMobileBombers,
				},
			],
			mobileBannerLink: "https://www.playnow.com/mb/sports/promotions/bombers-free-20/",
		},
		hideGetChips: false,
		hidePrizePage: false,
	},
	[TeamType.ELKS]: {
		logo: elksLogo,
		background: elksBg,
		altBackground: elksAltBg,
		mobileBackground: elksBgMWeb,
		name: "header.team.elks_name",
		registrationFields: {
			terms: true,
			marketing: true,
			sponsor: true,
		},
		sponsorData: {
			sponsorLogo: elksSponsorLogo,
			sponsorLogoHeader: elksSponsorLogoBlack,
			sponsorLogoAlt: elksSponsorLogoBlack,
			sponsorLink: "https://playalberta.ca/",
			mainBanner: elksMainBanner,
			mainBannerLink: "https://www.goelks.com/2024-tickets/",
			secondBanner: elksSecondBanner,
			secondBannerLink: "https://playalberta.ca/",
			mobileBanner: [
				{
					image: elksSecondBanner,
				},
			],
			mobileBannerLink: "https://playalberta.ca/",
		},
		hidePrizePage: false,
	},
	[TeamType.LIONS]: {
		logo: lionsLogo,
		background: lionsBg,
		name: "header.team.lions_name",
		registrationFields: {
			terms: true,
			marketing: true,
			sponsor: false,
		},
		sponsorData: {
			sponsorLogo: lionsSponsorLogo,
			sponsorLogoHeader: lionsSponsorLogoBlack,
			sponsorLogoAlt: lionsSponsorLogoBlack,
			chipsLogo: lionsChipsLogo,
			sponsorLogoAltRegistrationEnabled: true,
			sponsorLink:
				"https://www.playnow.com/sports/promotions/bc-lions-free-20/?utm_campaign=bclions24-sports-bc-acquisition&utm_source=bclions&utm_medium=display&utm_content=20-freebet",
			mainBanner: lionsMainBanner,
			mainBannerLink:
				"https://www.playnow.com/sports/promotions/bc-lions-free-20/?utm_campaign=bclions24-sports-bc-acquisition&utm_source=bclions&utm_medium=display&utm_content=20-freebet",
			secondBanner: lionsMainBanner,
			secondBannerLink:
				"https://www.playnow.com/sports/promotions/bc-lions-free-20/?utm_campaign=bclions24-sports-bc-acquisition&utm_source=bclions&utm_medium=display&utm_content=20-freebet/",
			mobileBanner: [
				{
					appearance: {minWidth: "970px", maxWidth: "100%"},
					image: lionsMainBanner970,
				},
				{
					appearance: {minWidth: "300px", maxWidth: "970px"},
					image: lionsMainBanner728,
				},
			],
			mobileBannerLink:
				"https://www.playnow.com/sports/promotions/bc-lions-free-20/?utm_campaign=bclions24-sports-bc-acquisition&utm_source=bclions&utm_medium=display&utm_content=20-freebet/",
		},
		hideGetChips: false,
		hidePrizePage: false,
	},
	[TeamType.REDBLACKS]: {
		logo: redblacksLogo,
		background: redblacksBg,
		name: "header.team.redblacks_name",
		hideGetChips: true,
		registrationFields: {
			terms: false,
			marketing: true,
			sponsor: false,
		},
		hidePrizePage: true,
	},
	[TeamType.RIDERS]: {
		logo: ridersLogo,
		background: ridersBg,
		name: "header.team.riders_name",
		registrationFields: {
			terms: true,
			marketing: true,
			sponsor: false,
		},
		hideGetChips: true,
		hidePrizePage: false,
	},
	[TeamType.STAMPS]: {
		logo: stampsLogo,
		background: stampsBg,
		name: "header.team.stamps_name",
		hideGetChips: true,
		registrationFields: {
			terms: true,
			marketing: true,
			sponsor: false,
		},
		sponsorData: {
			sponsorLink:
				"https://www.flowcode.com/page/stampsengage?utm_source=INTERNAL&utm_medium=DISPLAY&utm_campaign=BLITZ",
			mainBanner: stampsMainBanner,
			secondBanner: stampsSecondBanner,
			mainBannerLink:
				"https://www.flowcode.com/page/stampsengage?utm_source=INTERNAL&utm_medium=DISPLAY&utm_campaign=BLITZ",
			secondBannerLink:
				"https://www.flamesport.com/pages/calgary-stampeders?utm_source=INTERNAL&utm_medium=DISPLAY&utm_campaign=BLITZ",
			mobileBanner: [
				{
					image: stampsMainBannerMobile,
				},
			],
			mobileBannerLink:
				"https://www.flowcode.com/page/stampsengage?utm_source=INTERNAL&utm_medium=DISPLAY&utm_campaign=BLITZ",
		},
		hidePrizePage: false,
	},
	[TeamType.TICATS]: {
		logo: ticatsLogo,
		background: ticatsBg,
		name: "header.team.ticats_name",
		hideGetChips: false,
		registrationFields: {
			terms: true,
			marketing: true,
			sponsor: true,
		},
		sponsorData: {
			sponsorLink: "https://www.redtag.ca/",
			sponsorLogo: ticatsSponsorLogoHeader,
			sponsorLogoHeader: ticatsSponsorLogo,
			sponsorLogoAlt: ticatsSponsorLogo,
		},
		hidePrizePage: false,
	},
}[TEAM_PREFIX];
